






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import pluralize from '@/modules/shared/filters/pluralize.filter';

import Badge from '@/modules/loyalty/model/badge.model';
import { User } from '@/modules/user/model/user.model';
import Seller from '@/modules/user/model/seller.model';

import TableComponent, { TableHeader } from '@/modules/shared/components/table.component.vue';


@Component({
    components: {
        TableComponent,
    },
    computed: {
        ...mapGetters({
            sellerRankingList: 'getSellerRankingList',
            badgeList: 'getBadgeList',
            getBadge: 'getBadge',
            profile: 'getProfile',
        }),
    },
    methods: {
        ...mapActions({
            fetchSellerRankingList: 'fetchSellerRankingList',
            fetchBadgeList: 'fetchBadgeList',
        }),
    },
    filters: {
        pluralize,
    },
})
export default class GeneralRanking extends Vue {
    private fetchBadgeList!: any;
    private fetchSellerRankingList!: any;
    private sellerRankingList!: any[];
    private badgeList!: Badge[];
    private getBadge!: any;
    private profile!: User;
    private literals = {
        title: 'Clasificación general de ventas y niveles de puntos',
        sectionTitle: 'Correlación de ventas y nivel',
        point: 'Point',
        points: 'Points',
    };
    private headers: TableHeader[] = [
        {
            key: 'name',
            value: 'Vendedor',
        }, {
            key: 'position',
            value: 'Posición',
        }, {
            key: 'category',
            value: 'Rango',
        },
    ];


    private created() {
        this.fetchBadgeList();
        this.fetchSellerRankingList({ limit: 10 });
    }


    get list() {
        return this.sellerRankingList.map((item: any) => {
            let name = item.sellerCode;
            if ( item.user.id === this.profile.id) {
                name = `${item.user.firstName} ${item.user.lastName}`;
            }
            return {
                name,
                position: item.rankingPosition,
                category: item.badgeName,
            };
        });
    }

    get userBadge() {
        let name = '';
        const badge = this.getBadge((this.profile.seller as Seller).badge);
        if ( badge ) {
            name = badge.name;
        }
        return name;
    }
}
